import { render } from "./CardDiscover.vue?vue&type=template&id=ca2d023a"
const script = {}

import exportComponent from "../../../../Bocco/Rental/WebApp/Bocco/Rental/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__